import { Injectable } from '@angular/core';
import { Cache, CacheFactory } from 'cachefactory';

@Injectable({
    providedIn: 'root',
})
export class SharedCacheService {
    private cacheFactory: CacheFactory = new CacheFactory();
    private memoryCache: Cache;
    private localCache: Cache;

    constructor() {
        this.memoryCache = this.cacheFactory.createCache('data', {
            storageMode: 'memory',
            maxAge: 10 * 60 * 1000,
            deleteOnExpire: 'aggressive',
            cacheFlushInterval: 3600000 * 2,
            capacity: 200,
        });

        this.localCache = this.cacheFactory.createCache('local', {
            storageMode: 'localStorage',
            deleteOnExpire: 'aggressive',
            capacity: 200,
        });
    }

    public getMemory<T>(key: string): T {
        return this.memoryCache.get(key) as T;
    }

    public addMemory<T>(key: string, item: T): void {
        this.memoryCache.put(key, item);
    }

    public removeMemory(key: string): void {
        this.memoryCache.remove(key);
    }

    public flushMemory(): void {
        this.memoryCache.removeAll();
    }

    public getLocal<T>(key: string): T {
        return this.localCache.get(key) as T;
    }

    public addLocal<T>(key: string, value: T): void {
        this.localCache.put(key, value);
    }

    public removeLocal(key: string): void {
        this.localCache.remove(key);
    }

    public flushLocal(): void {
        this.localCache.removeAll();
    }

    public flushAll(): void {
        this.flushMemory();
        this.flushLocal();
    }
}
